import { useState, useEffect } from "react";
import { 
  subscribeToPOs, 
  addPO, 
  updatePO, 
  deletePO 
} from "../services/poService";

export function usePOs() {
  const [pos, setPos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let unsubscribe = () => {};

    try {
      setLoading(true);
      unsubscribe = subscribeToPOs((data, err) => {
        if (err) {
          setError("Failed to load POs.");
          setLoading(false);
          return;
        }

        setPos(data || []);
        setLoading(false);
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize PO subscription.");
      setLoading(false);
    }

    return () => unsubscribe();
  }, []);

  const handleAddPO = async (poData) => {
    try {
      setError("");
      return await addPO(poData);
    } catch (err) {
      console.error("Error adding PO:", err);
      setError(err.message || "Failed to add PO.");
      throw err;
    }
  };

  const handleUpdatePO = async (id, poData) => {
    try {
      setError("");
      await updatePO(id, poData);
    } catch (err) {
      console.error("Error updating PO:", err);
      setError(err.message || "Failed to update PO.");
      throw err;
    }
  };

  const handleDeletePO = async (id) => {
    try {
      setError("");
      await deletePO(id);
    } catch (err) {
      console.error("Error deleting PO:", err);
      setError(err.message || "Failed to delete PO.");
      throw err;
    }
  };

  return {
    pos,
    loading,
    error,
    setError,
    addPO: handleAddPO,
    updatePO: handleUpdatePO,
    deletePO: handleDeletePO
  };
}
